import { ReactNode } from "react";
import styled from "styled-components";

interface DescriptionProps {
  children: ReactNode;
}

export function Description({ children }: DescriptionProps) {
  return (
    <Content>
      { children }
    </Content>
  )
}

const Content = styled.p`
  max-width: 920px;
  background-color: #fff;
  margin: auto;
  color: ${({ theme }) => theme.colors.blue.dark};
  font-size: 22px;
  padding: 16px;
  transform: translateY(-32px);
  line-height: 1.4;
  margin-bottom: -16px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    transform: none;
    width: 100%;
    font-size: 18px;
    padding: 16px 32px;
    text-align: center;
  }
`;